import { Component, EventEmitter, Output } from '@angular/core';
import { VehicleModelService } from '../../crud-vehicle-module-cars/services/vehicle-model.service';
import { Vehicle } from '../../crud-vehicle-module-cars/vehicle';
import { AnalitycsService } from 'src/app/shared/service/analitycs.service';

@Component({
  selector: 'app-data-documents',
  templateUrl: './data-documents.component.html',
  styleUrl: './data-documents.component.css',
})
export class DataDocumentsComponent {
  @Output() vehicleSelected = new EventEmitter<string>();

  vehicles: Vehicle[] = [];

  constructor(
    private vehicleModelService: VehicleModelService,
    private analitycs: AnalitycsService,
  ) {
    // do nothing
  }
  ngOnInit() {
    this.analitycs.logEvent('el_usuario_ingresa_a_documentos', {
      pantalla: 'data-documents',
      accion: 'clic',
      plataforma: 'web',
      timestamp: new Date().toISOString(),
    });

    this.loadVehicles();
  }

  async loadVehicles(): Promise<void> {
    this.vehicles = await this.vehicleModelService.getVehicleModels();
  }
  selectVehicle(vehicleId: string) {
    this.analitycs.logEvent('el_usuario_selecciono_ver_ods', {
      pantalla: 'data-documents',
      accion: 'clic',
      plataforma: 'web',
      timestamp: new Date().toISOString(),
    });
    this.vehicleSelected.emit(vehicleId);
  }
}
